import type { Group, GroupLike, SubGroup } from '../../../../types.ts';

export const isGroup = (value: Group | SubGroup | undefined): value is Group => {
  return value !== undefined && !('groups' in value);
};

export const getRegionFromGroup = (group: GroupLike | undefined): string | null => {
  if (!isGroup(group) || !group.region) return null;

  return typeof group.region === 'string' && group.region !== '' ? group.region : null;
};

export const getCountriesFromGroup = (group: GroupLike | undefined): string[] => {
  if (!isGroup(group) || !group.countries || !Array.isArray(group.countries)) return [];

  return group.countries;
};
